import type { SpecsAutoFormFieldMetadataMap } from "../autoFormMetadata";
import { ObservableModelNode } from "../observable";
import { cloneValue, expectObject, splitKnown } from "../utils";

export class ProductVersionGeneratorMetadataModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    extra: {
      label: "Generator metadata JSON",
      fieldType: "json",
      minRows: 8,
    },
  };

  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "product version generator metadata");
    this.extra = splitKnown(source, []);
    return this;
  }

  save() {
    return cloneValue(this.extra);
  }
}
